import * as React from 'react';
/**
 * Returns a function, which gets the `ownerDocument` of the element.
 */
export var useDocument = function (ref) {
    var getElement = React.useCallback(function () { return ref.current && ref.current.element
        ? ref.current.element
        : ref.current; }, [ref]);
    var getDocument = React.useCallback(function () {
        var element = getElement();
        return element ? element.ownerDocument || document : document;
    }, [getElement]);
    return getDocument;
};
